module.exports = __webpack_public_path__ + "img/softinya-prop-1.3b35bde9.webp";